import { render, staticRenderFns } from "./VerifiedBadge.vue?vue&type=template&id=1d83f917&"
import script from "./VerifiedBadge.vue?vue&type=script&lang=js&"
export * from "./VerifiedBadge.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedBadge.vue?vue&type=style&index=0&id=1d83f917&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports